import Typography from '@material-ui/core/Typography';
import { useKnowledgeBuilderColors } from '../../../theme/knowledgeBuilderColors';
import { useKnowledgeBuilder } from '../KnowledgeBuilderProvider';
import { MarkdownPreview } from '../MarkdownPreview';
import { buildPendingPreviewDocumentForPath } from '../proposedChangePreview';

export const SectionPreview = () => {
  const colors = useKnowledgeBuilderColors();
  const { activeDocument, activeDocumentPath, documents, proposedChanges } =
    useKnowledgeBuilder();
  const proposedDocument = activeDocumentPath
    ? buildPendingPreviewDocumentForPath({
        path: activeDocumentPath,
        documents,
        proposedChanges,
      })
    : undefined;
  const previewDocument = proposedDocument ?? activeDocument;

  return (
    <main
      style={{
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
        background: colors.bg.panel,
      }}
    >
      {previewDocument ? (
        <>
          {proposedDocument && (
            <Typography
              style={{
                padding: '8px 12px',
                color: colors.status.warningText,
                background: colors.status.warningBg,
                borderBottom: `1px solid ${colors.status.warningBorder}`,
                fontSize: 12,
              }}
            >
              Previewing pending AI changes. Accept this section to apply them.
            </Typography>
          )}
          <MarkdownPreview document={previewDocument} />
        </>
      ) : (
        <Typography style={{ padding: 16, color: colors.text.muted, fontSize: 12 }}>
          Nothing drafted for this section yet.
        </Typography>
      )}
    </main>
  );
};
